module.exports = __webpack_public_path__ + "img/Wp_2016.2ebc1a6a.png";